import Vue from "vue";
import i18n from "vue-i18n";

import de from "vuetify/lib/locale/de";
import it from "vuetify/lib/locale/it";

Vue.use(i18n);

var l_de = {};

require
  .context("@", true, /de.json$/)
  .keys()
  .forEach(fileName => {
    l_de = { ...l_de, ...require.context("@", true, /de.json$/)(fileName) };
  });

var l_it = {};

require
  .context("@", true, /it.json$/)
  .keys()
  .forEach(fileName => {
    l_it = { ...l_it, ...require.context("@", true, /it.json$/)(fileName) };
  });

const messages = {
  it: {
    ...l_it,
    $vuetify: it
  },
  de: {
    ...l_de,
    $vuetify: de
  }
};

export default new i18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "de",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "de",
  messages
});
